// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1HD4t","content":"styles_content__2sXNf","checkbox":"styles_checkbox__1APn0","checkboxLabel":"styles_checkboxLabel__19Jvb"};